var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 67,
    viewBox: "0 0 110 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VISA",
    transform: "translate(0 -0.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    transform: "translate(0 0.303)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 67,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 66,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visa-2",
    "data-name": "visa",
    transform: "translate(11.467 20.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15132",
    "data-name": "Path 15132",
    d: "M184.8,204.961l4.366-24.561h6.822l-4.23,24.561Z",
    transform: "translate(-153.28 -179.581)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15133",
    "data-name": "Path 15133",
    d: "M184.8,204.961l5.594-24.561h5.594l-4.23,24.561Z",
    transform: "translate(-153.28 -179.581)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15134",
    "data-name": "Path 15134",
    d: "M268.877,176.692A17.307,17.307,0,0,0,262.6,175.6c-6.823,0-11.735,3.411-11.735,8.323,0,3.684,3.411,5.594,6.14,6.823s3.548,2.047,3.548,3.138c0,1.637-2.183,2.456-4.093,2.456a14.831,14.831,0,0,1-6.55-1.364l-.955-.409L248,200.161a22.126,22.126,0,0,0,7.778,1.364c7.232,0,12.008-3.411,12.008-8.6,0-2.865-1.774-5.049-5.867-6.823-2.456-1.228-3.957-1.91-3.957-3.138,0-1.092,1.228-2.183,3.957-2.183a12.515,12.515,0,0,1,5.185.955l.682.273,1.092-5.322Z",
    transform: "translate(-205.7 -175.6)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15135",
    "data-name": "Path 15135",
    d: "M268.877,176.692A17.307,17.307,0,0,0,262.6,175.6c-6.823,0-10.507,3.411-10.507,8.323,0,3.684,2.183,5.594,4.912,6.823s3.548,2.047,3.548,3.138c0,1.637-2.183,2.456-4.093,2.456a14.831,14.831,0,0,1-6.55-1.364l-.955-.409L248,200.161a22.126,22.126,0,0,0,7.778,1.364c7.232,0,12.008-3.411,12.008-8.6,0-2.865-1.774-5.049-5.867-6.823-2.456-1.228-3.957-1.91-3.957-3.138,0-1.092,1.228-2.183,3.957-2.183a12.515,12.515,0,0,1,5.185.955l.682.273,1.092-5.322Z",
    transform: "translate(-205.7 -175.6)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15136",
    "data-name": "Path 15136",
    d: "M372.182,180.4c-1.637,0-2.865.136-3.548,1.774L358.4,204.961h7.368l1.365-4.094h8.733l.819,4.094h6.55L377.5,180.4Zm-3.138,16.374c.409-1.228,2.729-7.232,2.729-7.232s.546-1.5.955-2.456l.409,2.32s1.364,6.14,1.637,7.5h-5.731Z",
    transform: "translate(-297.27 -179.581)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15137",
    "data-name": "Path 15137",
    d: "M373.819,180.4c-1.637,0-2.866.136-3.548,1.774L358.4,204.961h7.368l1.365-4.094h8.733l.819,4.094h6.55L377.5,180.4Zm-4.776,16.374c.546-1.365,2.729-7.232,2.729-7.232s.546-1.5.955-2.456l.409,2.32s1.364,6.14,1.637,7.5h-5.731Z",
    transform: "translate(-297.27 -179.581)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15138",
    "data-name": "Path 15138",
    d: "M61.434,198.256l-.682-3.548c-1.228-4.093-5.185-8.6-9.551-10.78l6.14,21.832h7.368L75.761,181.2H68.393Z",
    transform: "translate(-42.467 -180.245)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15139",
    "data-name": "Path 15139",
    d: "M61.434,198.256l-.682-3.548c-1.228-4.093-5.185-8.6-9.551-10.78l6.14,21.832h7.368L75.761,181.2h-6Z",
    transform: "translate(-42.467 -180.245)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15140",
    "data-name": "Path 15140",
    d: "M0,180.4l1.228.273c8.733,2.047,14.737,7.232,17.056,13.372l-2.456-11.6c-.409-1.637-1.637-2.047-3.138-2.047Z",
    transform: "translate(0 -179.581)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15141",
    "data-name": "Path 15141",
    d: "M0,180.4H0c8.733,2.047,15.965,7.368,18.284,13.509l-2.32-9.688a3.331,3.331,0,0,0-3.275-2.593Z",
    transform: "translate(0 -179.581)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15142",
    "data-name": "Path 15142",
    d: "M0,180.4H0c8.733,2.047,15.965,7.368,18.284,13.509l-1.637-5.322c-.409-1.637-.955-3.275-2.865-3.957Z",
    transform: "translate(0 -179.581)",
    fill: "#ed7c00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851",
    transform: "translate(8.869 3.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15143",
    "data-name": "Path 15143",
    d: "M68.92,210.045l-4.639-4.639L62.1,210.591l-.546-3.411c-1.228-4.093-5.185-8.6-9.552-10.78l6.14,21.832h7.368Z",
    transform: "translate(-52 -196.4)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15144",
    "data-name": "Path 15144",
    d: "M191.759,295.2l-5.867-6-1.092,6Z",
    transform: "translate(-162.149 -273.372)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15145",
    "data-name": "Path 15145",
    d: "M259.871,274.8h0c.546.546.819.955.682,1.5,0,1.637-2.183,2.456-4.094,2.456a14.832,14.832,0,0,1-6.55-1.364l-.955-.409L248,282.578a22.125,22.125,0,0,0,7.778,1.365c4.366,0,7.914-1.228,9.961-3.411Z",
    transform: "translate(-214.57 -261.428)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15146",
    "data-name": "Path 15146",
    d: "M364,237.475h6.413l1.364-4.093h8.733l.819,4.093h6.55l-2.32-9.961-8.187-7.914.409,2.183s1.364,6.14,1.637,7.5h-5.731c.546-1.364,2.729-7.232,2.729-7.232s.546-1.5.955-2.456",
    transform: "translate(-310.785 -215.643)",
    fill: "#051244"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/VISA-icon.7d660ef2.svg";
export { ForwardRef as ReactComponent };